import { SUPPORTED_LANGUAGES, type Language } from '@mcgames/i18n';
import { Button } from '@mcgames/ui';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '../i18n.ts';
import styles from './LanguageSwitch.module.css';

export function LanguageSwitch() {
  const { t, i18n } = useTranslation('admin');
  return (
    <div className={styles['switch']} role="group" aria-label={t('header.language')}>
      {SUPPORTED_LANGUAGES.map((language: Language) => (
        <Button
          key={language}
          size="sm"
          variant={i18n.language === language ? 'secondary' : 'ghost'}
          aria-pressed={i18n.language === language}
          lang={language}
          onClick={() => void setLanguage(i18n, language)}
        >
          {language.toUpperCase()}
        </Button>
      ))}
    </div>
  );
}
